import React, {Component} from 'react';
import {dataAutomationAttr} from 'helpers/ApplicationHelper';
import {hvCuiSaveLog} from 'actions/item';
import I18n from 'lib/i18n/i18n';
// import {
//     MediumPrimaryButton,
//     MediumSecondaryButton
// } from '@worthy-npm/clarity';
class TwoButtons extends Component {
    constructor(props) {
        super(props);
        this.addPhotoChange = this.addPhotoChange.bind(this);
        this.renderTwoButtons = this.renderTwoButtons.bind(this);
        // this.renderTwoButtonsClarity = this.renderTwoButtonsClarity.bind(this);
    }

    addPhotoChange() {
        this.props.onChange(this.props.message, this.props.position)
    }

    content(button){
        return this.props.message[button].text;
    }

    dataAutomation(button){
        const buttonInfo = this.props.message[button]
        return buttonInfo.dataAutomation ?  buttonInfo.dataAutomation: buttonInfo.text;
    }

    saveLog(){
        let logsData = this.props.logsData;
        hvCuiSaveLog(logsData.itemId, logsData.version, 'CALL VIP LINE NOW button clicked', this.props.message.key, true, this.props.message.button1.key);
    }

    renderTwoButtons() {
        let isCallNow = this.props.message.button1.callNow === 'true',
            uploadPhotoTest = this.props.message.type === 'add_photo_button_two',
            reschedule = this.props.message.key === 'two_buttons_reschedule';
        return (
            <div id={this.props.id} className={`message-input-container message-two-button input-root
            ${isCallNow ? 'margin-bottom' : ''}
            ${reschedule ? 'absolute-position' : ''}
            ${uploadPhotoTest ? 'uploadTwoButton' : ''}`}
            >
                {
                    (()=>{
                        return(
                            this.showFirstButton(isCallNow, uploadPhotoTest)
                        )

                    })()
                }

                <div className={`button ${this.props.message.button2.clarityComponent}`}
                     onClick={()=>{this.props.onClick(this.props.message,this.props.message.button2)}}
                     data-automation={dataAutomationAttr(this.dataAutomation("button2"))}
                     dangerouslySetInnerHTML={ {__html: this.content("button2")} }
                ></div>
                { this.props.message.bottomText ?
                    <div className="bottom-text-container">
                        <span className={`${uploadPhotoTest ? 'bottom-text-all' : 'bottom-text-content'}`}>
                            {this.props.message.bottomText}
                        </span>
                    </div> : null
                }
            </div>
        );
    }

    render(){
        //TODO - make clarity button to upload photo
        return this.renderTwoButtons()
    }

    showFirstButton(isCallNow, uploadPhotoTest){
        if (isCallNow){
            return <div className="button">
                <a href={`tel:${I18n.getString('common::phoneNumber')}`}
                   onClick={this.saveLog.bind(this)}
                   dangerouslySetInnerHTML={{__html: this.content("button1")}}></a>
            </div>
        }
        else if (uploadPhotoTest){
            return (
              <div className='button uploadButton' data-automation={dataAutomationAttr(this.dataAutomation("button1"))}>
                  <span className="uploadBtnText" dangerouslySetInnerHTML={ {__html: this.content("button1")} }></span>
                  <input type='file' className="uploadBtnFile" onChange={this.addPhotoChange} accept={this.props.accept}/>
              </div>
            )
        }
        else
        {
            return (
              <div className="button"
                   onClick={()=>{this.props.onClick(this.props.message,this.props.message.button1)}}
                   data-automation={dataAutomationAttr(this.content("button1"))}
                   dangerouslySetInnerHTML={ {__html: this.content("button1")} }
              ></div>
            )
        }
    }
}

export default TwoButtons;